import axios from 'axios';
import UtilServices from './UtilServices';

const ApiService = {
    //GET PERMISSÕES
    getPermissoes (url) {
        const permissoesusuario = UtilServices.getStorage('perfilselecionado') || [];
        // Extrair o nome do app da url
        const nomeAppDaUrl = url.split('/')[1]; 
        // Filtra ele nos perfil ativo.
        const permissoesFiltradas = permissoesusuario?.filter(item => item.nomeApp === nomeAppDaUrl)[0] || {};
        // Retornar as permissões filtradas
        return permissoesFiltradas;
    },
    //POST
    async post(url, params) {
        try {
            params.Perfil = this.getPermissoes(url);
            const paramsCrypto = UtilServices.cryptografar(params);

            const response = await axios.post(url, paramsCrypto);
            return UtilServices.decompressData(response.data);
        } catch (error) {
            UtilServices.errorApi(error);
            throw error;
        }
    },
    //GET
    async get(url,params) {
        try {
            params.Perfil = this.getPermissoes(url);
            const paramsCrypto = UtilServices.cryptografar(params);

            const response = await axios.get(url, {
                params: paramsCrypto
            });
            return UtilServices.decompressData(response.data);
        } catch (error) {
            UtilServices.errorApi(error);
            throw error;
        }
    },
    //PUT
    async put(url, params) {
        try {
            params.Perfil = this.getPermissoes(url);
            const paramsCrypto = UtilServices.cryptografar(params);

            const response = await axios.put(url, paramsCrypto);
            return UtilServices.decompressData(response.data);
        } catch (error) {
            UtilServices.errorApi(error);
            throw error;
        }
    },
    //DELETE
    async delete(url, params) {
        try {
            params.Perfil = this.getPermissoes(url);
            const paramsCrypto = UtilServices.cryptografar(params);

            const response = await axios.delete(url, {
                params: paramsCrypto
            });
            return UtilServices.decompressData(response.data);
        } catch (error) {
            UtilServices.errorApi(error);
            throw error;
        }
    },
};

const EndPointServices = {
    /* --- Autenticar --- */
    Autentica_Login(params) {
        const endpoint = `/Autentica/Login`;
        return ApiService.post(endpoint, params);
    },
    Autentica_Permissoes(params) {
        const endpoint = `/Autentica/Permissoes`;
        return ApiService.get(endpoint, params);
    },
    Autentica_MudarSenha(params) {
        const endpoint = `/Autentica/MudarSenha`;
        return ApiService.post(endpoint, params);
    },
    // Autentica_DadosTeste(params) { //#Desativar
    //     const endpoint = `/Autentica/DadosTeste`;
    //     return ApiService.post(endpoint, params);
    // },
    /* --- CAD --- */
    // Empresa
    CAD_EmpresaConsultar(params) {
        const endpoint = `/CAD/Empresa/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_EmpresaEditar(params) {
        const endpoint = `/CAD/Empresa/Editar`; 
        return ApiService.post(endpoint, params);
    },
    CAD_EmpresaAtivarInativar(params) {
        const endpoint = `/CAD/Empresa/AtivarInativar`;
        return ApiService.delete(endpoint, params);
    },
    CAD_EmpresaAdicionar(params) {
        const endpoint = `/CAD/Empresa/Adicionar`;
        return ApiService.post(endpoint, params);
    },
    CAD_EmpresaDetalhadaConsultar(params) {
        const endpoint = `/CAD/Empresa/Detalhada/Consultar`;
        return ApiService.get(endpoint, params);
    },
    
    //Endereco
    CAD_EnderecoConsultar(params) {
        const endpoint = `/CAD/Endereco/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_EnderecoAdicionar(params) {
        const endpoint = `/CAD/Endereco/Adicionar`;
        return ApiService.post(endpoint, params);
    },
    CAD_EnderecoEmpresaExcluir(params) {
        const endpoint = `/CAD/Endereco/Excluir`;
        return ApiService.delete(endpoint, params);
    },
    CAD_EnderecoSocioExcluir(params) {
        const endpoint = `/CAD/Endereco/Socio/Excluir`;
        return ApiService.delete(endpoint, params);
    },

    // Contato
    CAD_ContatoConsultar(params) {
        const endpoint = `/CAD/Contato/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_ContatoEditar(params) {
        const endpoint = `/CAD/Contato/Editar`;
        return ApiService.post(endpoint, params);
    },

    // Socio
    CAD_SocioConsultar(params) {
        const endpoint = `/CAD/Socio/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_SocioDetalhadaConsultar(params) {
        const endpoint = `/CAD/Socio/Detalhada/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_SocioDadosConsultar(params) {
        const endpoint = `/CAD/Socio/Dados/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_SocioEditar(params) {
        const endpoint = `/CAD/Socio/Editar`;
        return ApiService.post(endpoint, params);
    },
    CAD_SocioAtivarInativar(params) {
        const endpoint = `/CAD/Socio/AtivarInativar`;
        return ApiService.delete(endpoint, params);
    },
    CAD_SocioDadosAtivarInativar(params) {
        const endpoint = `/CAD/Socio/Dados/AtivarInativar`;
        return ApiService.delete(endpoint, params);
    },
    CAD_SocioAdicionar(params) {
        const endpoint = `/CAD/Socio/Adicionar`;
        return ApiService.post(endpoint, params);
    },
    
    // Label
    CAD_LabelConsultar(params) {
        const endpoint = `/CAD/Label/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_LabelConsultar_Config(params) {
        const endpoint = `/CAD/Label/Consultar/Config`;
        return ApiService.get(endpoint, params);
    },
    CAD_LabelEditar(params) {
        const endpoint = `/CAD/Label/Editar`;
        return ApiService.post(endpoint, params);
    },
    CAD_LabelEditar_Config(params) {
        const endpoint = `/CAD/Label/Editar/Config`;
        return ApiService.post(endpoint, params);
    },

    //Historico
    CAD_HistoricoFieldConsultar(params) {
        const endpoint = `/CAD/Historico/Field/Consultar`;
        return ApiService.get(endpoint, params);
    },
    CAD_HistoricoConsultar(params) {
        const endpoint = `/CAD/Historico/Consultar`;
        return ApiService.get(endpoint, params);
    },
    /* --- ALT --- */
    ALT_ConsultaNotificacaoContagem(params) {
        const endpoint = `/ALT/Notificacao/Consultar/Contagem`;
        return ApiService.get(endpoint, params);
    },
    ALT_ConsultaNotificacao(params) {
        const endpoint = `/ALT/Notificacao/Consultar`;
        return ApiService.get(endpoint, params);
    },
    ALT_AdicionarNotificacao(params) {
        const endpoint = `/ALT/Notificacao/Adicionar`;
        return ApiService.post(endpoint, params);
    },
    /* --- ECAC --- */
    ECAC_SituacaoFiscal_ConsultaDashBoard(params) {
        const endpoint = `/ECAC/SituacaoFiscal/DashBoard/Consultar`;
        return ApiService.get(endpoint, params);
    },
    ECAC_SituacaoFiscal_ConsultaAnalitico(params) {
        const endpoint = `/ECAC/SituacaoFiscal/Analitico/Consultar`;
        return ApiService.get(endpoint, params);
    },
    /* --- Apis Partilha --- */
    Partilha_ConsultarLista(params) {
        const endpoint = `/Partilha/Lista`;
        return ApiService.get(endpoint, params);
    },
    Partilha_ConsultarMenuLateral(params) {
        const endpoint = `/Partilha/ConsultarMenuLateral`;
        return ApiService.get(endpoint, params);
    },


    /* --- Apis Externas --- */
    async Externo_ConsultaMunicipios(){
        try {
            const response = await fetch("https://servicodados.ibge.gov.br/api/v1/localidades/municipios");
            if (!response.ok) {
                throw new Error(`Erro na requisição: ${response.status}`);
            }
            const municipios = await response.json();
            return municipios;
        } catch (error) {
            UtilServices.errorApi(error);
        }
    },
    async Externo_ConsultaCnpj(params) {
        const endpoint = `/CAD/Empresa/ConsultaCnpj`;
        return ApiService.get(endpoint, params);
    },
    async Externo_ConsultaCnaes(){
        try {
            const response = await fetch("https://api.listacnae.com.br/v1/todosCnaes", {
                method: "GET",
                headers: {
                    "Authorization": "Bearer 194B93546E9-E9943343DBDD8DBE-2IHLNYIFW1TWGLSXPXFT6VNABNCAKKBO"
                }
            });
    
            if (!response.ok) {
                throw new Error(`Erro na requisição: ${response.status}`);
            }
            const cnaes = await response.json();
            return cnaes;
        } catch (error) {
            UtilServices.errorApi(error);
        }
    },
    async Externo_ConsultaCEP(cep){
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
                method: "GET",
            });
            if (!response.ok) {
                throw new Error(`Erro na requisição: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            UtilServices.errorApi(error);
        }
    },
    async Externo_VerificaTokenCaptcha(params) {
        const endpoint = `/Autentica/VerificaTokenCaptcha`;
        return ApiService.post(endpoint, params);
    },
};

export default EndPointServices;

